import { render, staticRenderFns } from "./CustomerManagementRegisterOpt.vue?vue&type=template&id=752291fa&scoped=true&"
import script from "./CustomerManagementRegisterOpt.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementRegisterOpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752291fa",
  null
  
)

export default component.exports